import type { ReactElement } from "react";

export function KrisBadge(): ReactElement {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#E8F9F9] px-3 py-1.5 text-xs font-medium text-[#029391] whitespace-nowrap">
      <svg className="h-3 w-3" viewBox="0 0 12 12" fill="currentColor">
        <circle cx="6" cy="6" r="6" fillOpacity="0.3" />
        <circle cx="6" cy="6" r="3" />
      </svg>
      Powered by Kris@Work
    </span>
  );
}
